import React from 'react';
import { Routes, Route } from 'react-router-dom';
import Layout from './components/Layout';
import Hero from './components/Hero';
import About from './components/About';
import TechExpertise from './components/TechExpertise';
import ProjectsGrid from './components/ProjectsGrid';
import DesignShowcase from './components/DesignShowcase';
import Contact from './components/Contact';
import ProjectDetail from './components/ProjectDetail';
import SEO from './components/SEO';
import StructuredData from './components/StructuredData';
import SmoothScrollProvider from './components/scroll/SmoothScrollProvider';
// import ScrollPathAnimation from './components/scroll/ScrollPathAnimation'; // Disabled - user doesn't like it
import './App.css';

function HomePage() {
  return (
    <>
      <SEO />
      <StructuredData />
      <Hero />
      <About />
      <TechExpertise />
      <ProjectsGrid />
      <DesignShowcase />
      <Contact />
    </>
  );
}

function App() {
  return (
    <SmoothScrollProvider>
      {/* <ScrollPathAnimation /> */}
      <Routes>
        <Route path="/" element={<Layout><HomePage /></Layout>} />
        <Route path="/projects/:id" element={<Layout><ProjectDetail /></Layout>} />
      </Routes>
    </SmoothScrollProvider>
  );
}

export default App;
